<template>
    <div class="product-single page-wrapper" v-loading="loading">
        <div class="product-single-inner" v-if="!loading">
            <div class="product-single-image" v-if="!!product.assets && product.assets[0]" :class="{ full : choosenSize === 2 }">
              <img :src="getbase64EncodedImage(product.assets[0].attributes['com.extensis.portfolio.Preview'][0])" />
            </div>

            <div class="product-single-details" v-if="!!product.assets">

                <div class="product-action">
                  <a href="#" @click.prevent="request" class="button full">select</a>
                  <a href="#" class="button white half" @click.prevent="addToFavorites">save for later
                  </a>
                  <a href="#" class="button white half" @click.prevent="download()">
                    download
                  </a>
                  <a href="#" class="button white half" @click.prevent="share()">
                    email
                  </a>
                </div>

                <template v-for="value in product.fieldsToShow">
                    <template v-if="typeof product.assets[0].attributes[value] !== 'undefined'">
                        <div v-if="['Path', 'com.extensis.portfolio.Preview', 'Sub Category'].indexOf(value) === -1" :key="value" class="product-single-details-meta">
                          <template v-if="value === 'Keywords'">
                            <p class="label">{{ filterName(value) }}</p>
                            <div class="keywords">
                              <template v-if="product.assets[0].attributes[value].length > 1">
                                <a v-for="(val) in product.assets[0].attributes[value]" class="button gray" @click="setSearch(val)" :key="val">
                                     {{ val }}
                                </a>
                              </template>
                              <template v-else>
                                  <a @click="setSearch(product.assets[0].attributes[value][0])" class="button gray" :key="product.assets[0].attributes[value][0]">
                                      {{ product.assets[0].attributes[value][0] }}
                                  </a>
                              </template>
                            </div>
                          </template>
                          <template v-else>
                            <p class="label">{{ filterName(value) }}</p>
                            <template v-if="product.assets[0].attributes[value].length > 1">
                              <p>
                                    <span @click="setSearch(val)" v-for="(val, ind) in product.assets[0].attributes[value]" :key="val">
                                        {{ val }}{{ ind + 1 !== product.assets[0].attributes[value].length ? ',' : ''}}
                                    </span>
                              </p>
                            </template>
                            <template v-else>
                              <p>
                                    <span @click="setSearch(product.assets[0].attributes[value][0])" :key="product.assets[0].attributes[value][0]">
                                        {{ product.assets[0].attributes[value][0] }}
                                    </span>
                              </p>
                            </template>
                          </template>
                        </div>
                        <div v-if="value === 'Sub Category' && Object.keys(product.assets[0].attributes[value]).length" :key="value" class="product-single-details-meta">
                            <p class="label">{{ filterName(value) }}</p>
                            <p>
                                <template v-for="(sub, index) in product.assets[0].attributes[value]">
                                    <template v-if="sub.length > 1">
                                        <span @click="setSearch(val)" v-for="(val, ind) in sub"  :key="val">
                                            {{ val }}{{ ind+1 !== sub.length ? ',' : ''}}{{ Object.keys(product.assets[0].attributes[value]).indexOf(index) + 1 !== Object.keys(product.assets[0].attributes[value]).length ? ',' : ''}}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <span @click="setSearch(sub[0])" :key="sub[0]">
                                            {{ sub[0] }}{{ Object.keys(product.assets[0].attributes[value]).indexOf(index) + 1 !== Object.keys(product.assets[0].attributes[value]).length ? ',' : ''}}
                                        </span>
                                    </template>
                                </template>
                            </p>
                        </div>
                    </template>
                </template>

            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from '@/services/api'
import { EventBus } from '@/services/eventbus'

export default {
  name: 'ProductSingle',
  metaInfo () {
    return {
      title: 'Product'
    }
  },
  data () {
    return {
      loading: false,
      choosenSize: 1,
      product: {},
      subcategories: {},
      imageHeight: null,
      windowWidth: null
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted () {
    if (this.$store.state.folders.length && !this.loading) {
      this.loadData(this.$route.params.id)
    }
    EventBus.$emit('list-scroll-loader', false)
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    '$store.state.folders': function (oldVal, newVal) {
      if (newVal && oldVal !== newVal) {
        this.loadData(this.$route.params.id)
      }
    }
  },
  methods: {
    handleResize () {
      this.windowWidth = window.innerWidth
    },
    imageSize (id) {
      this.choosenSize = id
    },
    getbase64EncodedImage (item) {
      let src = 'data:image/jpeg;base64,' + item.replace(/(\r\n|\n|\r)/gm, '')
      let scope = this
      var i = document.createElement('img')
      i.onload = function () {
        scope.imageHeight = (scope.windowWidth - 20) / (i.width / i.height)
      }
      i.src = src
      return src
    },
    filterName (name) {
      switch (name) {
        case 'File Description':
          return 'Description'
        default:
          return name
      }
    },
    loadData (id) {
      this.loading = true
      EventBus.$emit('list-scroll-loader', false)
      HTTP({
        method: 'GET',
        url: '/api/v1/assets/' + id,
        crossdomain: true
      }).then(response => {
        this.product = response.data.data

        if (typeof this.product.assets[0].attributes.Category !== 'undefined') {
          for (let cat in this.product.assets[0].attributes.Category) {
            let categoryName = this.product.assets[0].attributes.Category[cat]
            if (typeof this.product.assets[0].attributes[categoryName] !== 'undefined') {
              this.subcategories[categoryName] = this.product.assets[0].attributes[categoryName]
            }
          }
        }

        this.loading = false
        EventBus.$emit('list-scroll-loader', false)
        this.setFolderBasedOnAsset()
      }).catch(() => {
        this.loading = false
      })
    },
    setFolderBasedOnAsset () {
      if (typeof this.product.assets[0].attributes.Path !== 'undefined') {
        let scope = this
        let index = this.$store.state.folders.findIndex(function (folder) {
          return scope.product.assets[0].attributes.Path[0].indexOf(folder.path) === 0
        })
        if (index > -1) {
          this.selectFolder(this.$store.state.folders[index])
        }
      }
    },
    share () {
      EventBus.$emit('open-modal', {
        type: 'public-asset-share',
        header: false,
        data: {
          ids: [this.product.assets[0].id],
          filenames: this.product.assets[0].attributes.Filename
        }
      })
    },
    download () {
      this.loading = true
      HTTP({
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        method: 'GET',
        responseType: 'arraybuffer',
        url: '/api/v1/assets/download',
        crossdomain: true,
        params: {
          ids: [
            this.product.assets[0].id
          ]
        }
      })
        .then(response => {
          let headers = response.headers
          let blob = new Blob([response.data], { type: headers['content-type'] })
          let link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = this.product.assets[0].attributes.Filename
          link.click()
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    request () {
      this.$store.dispatch('addRequestItem', this.product.assets[0])
      this.$notify({
        message: 'Added to selects',
        type: 'success',
        position: 'bottom-right',
        duration: 1750
      })
    },
    addToFavorites () {
      HTTP({
        method: 'POST',
        url: '/api/v1/favorites',
        crossdomain: true,
        data: {
          ids: [parseInt(this.product.assets[0].id)]
        }
      })
        .then(response => {
          if (response.data.data) {
            this.$store.dispatch('setFavorites', response.data.data)
            this.$notify({
              // title: 'Success',
              message: 'Added to saved items',
              type: 'success',
              position: 'bottom-right',
              duration: 1750
            })
          }
        })
        .catch((error) => {
          this.$notify({
            // title: 'Error',
            dangerouslyUseHTMLString: true,
            message: error.response.data ? this.parseErrorMessage(error.response.data.error) : 'Error occured. Please try later',
            type: 'error',
            position: 'bottom-right',
            duration: 1750
          })
        })
    },
    setSearch (search) {
      this.$router.push({ name: 'home', params: { search: '"' + search + '"' } })
    }
  }
}
</script>
